/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type PurchaseGooseGameStoreItemsMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
  items: Array<Types.PurchaseItemInput> | Types.PurchaseItemInput;
  event_id: Types.Scalars["Float"];
}>;

export type PurchaseGooseGameStoreItemsMutation = {
  purchaseGooseGameStoreItems: Array<Pick<Types.GooseGameItem, "id">>;
};

export const PurchaseGooseGameStoreItemsDocument = gql`
  mutation PurchaseGooseGameStoreItems(
    $event_attendee_id: Float!
    $items: [PurchaseItemInput!]!
    $event_id: Float!
  ) {
    purchaseGooseGameStoreItems(
      event_attendee_id: $event_attendee_id
      items: $items
      event_id: $event_id
    ) {
      id
    }
  }
`;

/**
 * __usePurchaseGooseGameStoreItemsMutation__
 *
 * To run a mutation, you first call `usePurchaseGooseGameStoreItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseGooseGameStoreItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseGooseGameStoreItemsMutation, { data, loading, error }] = usePurchaseGooseGameStoreItemsMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      items: // value for 'items'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function usePurchaseGooseGameStoreItemsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PurchaseGooseGameStoreItemsMutation,
    PurchaseGooseGameStoreItemsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    PurchaseGooseGameStoreItemsMutation,
    PurchaseGooseGameStoreItemsMutationVariables
  >(PurchaseGooseGameStoreItemsDocument, baseOptions);
}
export type PurchaseGooseGameStoreItemsMutationHookResult = ReturnType<
  typeof usePurchaseGooseGameStoreItemsMutation
>;
export type PurchaseGooseGameStoreItemsMutationResult =
  ApolloReactCommon.MutationResult<PurchaseGooseGameStoreItemsMutation>;
export type PurchaseGooseGameStoreItemsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    PurchaseGooseGameStoreItemsMutation,
    PurchaseGooseGameStoreItemsMutationVariables
  >;
